// product-media-swiper.js (revisi)
(function () {
  function initializeProductMediaSwiper() {
    // thumbs swiper: horizontal strip below the main image on mobile,
    // vertical rail to the left of it from 750px up (matches Dawn's breakpoint).
    var productMediaSwiperThumbs = new Swiper('.product-media-swiper__thumbs .swiper-container', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 8,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      observer: true,
      observeParents: true,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true
      },
      breakpoints: {
        750: {
          direction: 'vertical',
          spaceBetween: 12,
          // Without freeMode, Swiper's mousewheel plugin snaps to the next/
          // previous slide per wheel tick — with ~30 thumbnails that reads as
          // stuttering instead of a continuous scroll. freeMode lets the rail
          // follow the wheel delta directly (with momentum), matching a plain
          // scrollable list. Scoped to this breakpoint only, so the mobile
          // horizontal strip keeps its original touch-snap behavior.
          freeMode: true,
          freeModeMomentum: true,
          freeModeMomentumRatio: 0.8
        }
      }
    });

    // main swiper
    var productMediaSwiperMain = new Swiper('.product-media-swiper__main .swiper-container', {
      thumbs: { swiper: productMediaSwiperThumbs },
      observer: true,
      observeParents: true
    });

    // Defensive re-measure on viewport width changes (device rotation, the
    // Shopify theme editor's mobile/desktop preview toggle, or a browser
    // window resize) — Swiper's own resize handling is debounced and can
    // otherwise leave a stale slide width from before the breakpoint change.
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', debounce(function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      productMediaSwiperThumbs.update();
      productMediaSwiperMain.update();
    }, 200));

    setupHoverZoom(productMediaSwiperMain);
    setupThumbsHeightSync(productMediaSwiperThumbs);

    // --- custom controls hookup ---
    var thumbsRoot = document.querySelector('.product-media-swiper__thumbs');
    if (!thumbsRoot) return;

    var galleryRoot = document.querySelector('.product-media-swiper');
    var controlsRoot = galleryRoot && galleryRoot.querySelector('.product-media-swiper__controls');
    if (!controlsRoot) return;

    var prevBtn = controlsRoot.querySelector('.media-controls__prev');
    var nextBtn = controlsRoot.querySelector('.media-controls__next');
    var dotsRow = controlsRoot.querySelector('.media-controls__dots');
    var counterEl = controlsRoot.querySelector('.media-controls__counter');

    // --- Adaptive chevron contrast: switch to a dark 20% background when the
    // image behind a chevron is light/white, so it stays visible (default
    // stays white 20% for the common dark-photo case). Brightness is sampled
    // from the actual image pixels behind each button, not guessed from theme
    // color scheme, since it depends on the specific product photo. ---
    var chevronBrightnessCache = {};

    function sampleRegionBrightness(img, xFracCenter, cacheKeySuffix) {
      if (!img) return Promise.resolve(null);
      var srcUrl = img.currentSrc || img.src;
      if (!srcUrl) return Promise.resolve(null);
      var cacheKey = srcUrl + '|' + cacheKeySuffix;
      if (Object.prototype.hasOwnProperty.call(chevronBrightnessCache, cacheKey)) {
        return Promise.resolve(chevronBrightnessCache[cacheKey]);
      }

      return new Promise(function (resolve) {
        var probe = new Image();
        probe.crossOrigin = 'anonymous';
        probe.onload = function () {
          try {
            var wFrac = 0.2, hFrac = 0.35, yFracCenter = 0.5;
            var sw = Math.max(1, Math.round(probe.naturalWidth * wFrac));
            var sh = Math.max(1, Math.round(probe.naturalHeight * hFrac));
            var sx = Math.round(probe.naturalWidth * xFracCenter - sw / 2);
            var sy = Math.round(probe.naturalHeight * yFracCenter - sh / 2);
            sx = Math.max(0, Math.min(sx, probe.naturalWidth - sw));
            sy = Math.max(0, Math.min(sy, probe.naturalHeight - sh));

            var canvas = document.createElement('canvas');
            var scale = 20 / Math.max(sw, sh);
            canvas.width = Math.max(1, Math.round(sw * scale));
            canvas.height = Math.max(1, Math.round(sh * scale));
            var ctx = canvas.getContext('2d');
            ctx.drawImage(probe, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
            var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
            var total = 0, count = 0;
            for (var i = 0; i < data.length; i += 4) {
              total += 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
              count++;
            }
            var brightness = count ? total / count : null;
            chevronBrightnessCache[cacheKey] = brightness;
            resolve(brightness);
          } catch (e) {
            // Canvas tainted (CDN didn't allow CORS) or other failure —
            // leave the chevron on its default white 20% background.
            resolve(null);
          }
        };
        probe.onerror = function () { resolve(null); };
        probe.src = srcUrl;
      });
    }

    function applyChevronContrast(btn, brightness) {
      if (!btn || brightness == null) return;
      btn.classList.toggle('media-controls__btn--on-light', brightness > 200);
    }

    function updateChevronContrast() {
      if (!prevBtn && !nextBtn) return;
      if (!productMediaSwiperMain || !productMediaSwiperMain.slides) return;
      var activeSlideEl = productMediaSwiperMain.slides[productMediaSwiperMain.activeIndex];
      if (!activeSlideEl) return;
      var img = activeSlideEl.querySelector('img');
      if (!img) return;

      function run() {
        sampleRegionBrightness(img, 0.12, 'prev').then(function (b) { applyChevronContrast(prevBtn, b); });
        sampleRegionBrightness(img, 0.88, 'next').then(function (b) { applyChevronContrast(nextBtn, b); });
      }

      if (img.complete && img.naturalWidth) {
        run();
      } else {
        img.addEventListener('load', run, { once: true });
      }
    }

    if (productMediaSwiperMain && typeof productMediaSwiperMain.on === 'function') {
      productMediaSwiperMain.on('slideChange', updateChevronContrast);
    }
    setTimeout(updateChevronContrast, 300);

    // debounce helper
    function debounce(fn, wait) {
      var t;
      return function() { clearTimeout(t); t = setTimeout(fn, wait || 80); };
    }

    // utility: get unique (non-duplicate) slide elements from main swiper
    function getUniqueSlideElements() {
      if (!productMediaSwiperMain || !productMediaSwiperMain.slides) return [];
      return Array.from(productMediaSwiperMain.slides).filter(function (el) {
        return !el.classList.contains('swiper-slide-duplicate');
      });
    }

    // utility: get unique slide count
    function getUniqueSlideCount() {
      var unique = getUniqueSlideElements();
      return unique.length;
    }

    // Ensure dotsRow is scrollable and hide native scrollbar where possible
    function enableDotsRowScrolling() {
      if (!dotsRow) return;
      dotsRow.style.overflowX = 'auto';
      dotsRow.style.WebkitOverflowScrolling = 'touch';
      dotsRow.classList.add('hide-scrollbar');
      dotsRow.style.scrollBehavior = 'smooth';
      // ensure it's a flex container so children width/offsetLeft works predictably
      dotsRow.style.display = 'flex';
      dotsRow.style.alignItems = 'center';
    }

    // dots are fixed-size circular bullets (sized via CSS .media-controls__dot);
    // just make sure the row doesn't try to center/stretch them when it overflows
    function adjustDotWidths() {
      if (!dotsRow) return;
      if (dotsRow.children.length === 0) return;
      dotsRow.style.justifyContent = 'flex-start';
    }

    // Build dots using unique slide count (ignores swiper duplicates)
    function buildDots() {
      if (!dotsRow) return;
      dotsRow.innerHTML = '';
      var count = getUniqueSlideCount();

      // if still 0, retry shortly (Swiper may initialize slightly later)
      if (count <= 0) {
        setTimeout(buildDots, 120);
        return;
      }

      if (count <= 1) {
        controlsRoot.style.display = 'none';
        return;
      } else {
        controlsRoot.style.display = '';
      }

      enableDotsRowScrolling();

      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'media-controls__dot';
        btn.setAttribute('data-media-index', String(i));
        btn.setAttribute('aria-label', 'Show media ' + (i + 1));
        btn.setAttribute('role', 'tab');

        (function(index){
          btn.addEventListener('click', function(){
            if (!productMediaSwiperMain) return;
            // if loop enabled, prefer slideToLoop if supported
            if (productMediaSwiperMain.params && productMediaSwiperMain.params.loop && typeof productMediaSwiperMain.slideToLoop === 'function') {
              productMediaSwiperMain.slideToLoop(index);
            } else if (typeof productMediaSwiperMain.slideTo === 'function') {
              // fallback to slideTo — modern Swiper accepts the "real" index often, but this is a safe best-effort
              productMediaSwiperMain.slideTo(index);
            }
          });
        })(i);

        dotsRow.appendChild(btn);
      }

      // ensure initial active marked and sizes adjusted
      // small delay to allow styles to apply
      setTimeout(function(){
        adjustDotWidths();
        // show first segment at initial render (per request)
        scrollDotsToIndex(0, false);
        updateActiveDot();
      }, 10);
    }

    // scroll the dotsRow so dot at index is visible & ideally centered (clamped)
    function scrollDotsToIndex(index, smooth) {
      if (!dotsRow) return;
      var dot = dotsRow.children[index];
      if (!dot) return;

      var containerWidth = dotsRow.clientWidth;
      var dotLeft = dot.offsetLeft;
      var dotWidth = dot.offsetWidth;

      // target left so that dot is centered in the visible area (or clamped)
      var target = Math.max(0, Math.floor(dotLeft - (containerWidth - dotWidth) / 2));

      // clamp target between 0 and maxScrollLeft
      var maxScroll = Math.max(0, dotsRow.scrollWidth - containerWidth);
      if (target > maxScroll) target = maxScroll;
      if (target < 0) target = 0;

      if (typeof dotsRow.scrollTo === 'function') {
        dotsRow.scrollTo({ left: target, behavior: smooth === false ? 'auto' : 'smooth' });
      } else {
        dotsRow.scrollLeft = target;
      }
    }

    // Find the active index mapped to unique slides (works with loop or non-loop)
    function getCurrentUniqueIndex() {
      if (!productMediaSwiperMain) return 0;
      // preferred: use realIndex if available
      if (typeof productMediaSwiperMain.realIndex === 'number') {
        return productMediaSwiperMain.realIndex;
      }

      // fallback: map active slide element to index among unique slides
      var activeIndex = productMediaSwiperMain.activeIndex || 0;
      var allSlides = Array.from(productMediaSwiperMain.slides || []);
      var uniqueSlides = getUniqueSlideElements();
      var activeSlideEl = allSlides[activeIndex] || null;

      if (!activeSlideEl) {
        // as last resort use modulo mapping if activeIndex out of range
        if (uniqueSlides.length > 0) return activeIndex % uniqueSlides.length;
        return 0;
      }

      // try direct identity match
      var foundIndex = uniqueSlides.indexOf(activeSlideEl);
      if (foundIndex >= 0) return foundIndex;

      // try to match by data-media-id attribute (common in Shopify generated slides)
      var activeMediaId = activeSlideEl.getAttribute && activeSlideEl.getAttribute('data-media-id');
      if (activeMediaId) {
        for (var i=0; i<uniqueSlides.length; i++) {
          if (uniqueSlides[i].getAttribute && uniqueSlides[i].getAttribute('data-media-id') === activeMediaId) {
            return i;
          }
        }
      }

      // if loop / duplicates produced mismatched element, try modulo as safe fallback
      if (uniqueSlides.length > 0) return activeIndex % uniqueSlides.length;

      return 0;
    }

    function updateActiveDot() {
      if (!productMediaSwiperMain) return;
      var idx = getCurrentUniqueIndex();

      if (counterEl) {
        counterEl.textContent = (idx + 1) + '/' + getUniqueSlideCount();
      }

      if (!dotsRow) return;
      var dots = Array.from(dotsRow.children);

      dots.forEach(function(d, i){
        if (i === idx) {
          d.classList.add('media-controls__dot--active');
          d.setAttribute('aria-selected','true');
          d.setAttribute('tabindex','0');
        } else {
          d.classList.remove('media-controls__dot--active');
          d.setAttribute('aria-selected','false');
          d.setAttribute('tabindex','-1');
        }
      });

      // Update arrows disabled state when not looped
      if (productMediaSwiperMain && productMediaSwiperMain.params && !productMediaSwiperMain.params.loop) {
        prevBtn && prevBtn.setAttribute('aria-disabled', (idx <= 0) ? 'true' : 'false');
        nextBtn && nextBtn.setAttribute('aria-disabled', (idx >= (getUniqueSlideCount() - 1)) ? 'true' : 'false');
      }

      // make sure the active dot is visible / centered (clamped)
      scrollDotsToIndex(idx, true);
    }

    // Attach events from Swiper to manage dots
    if (productMediaSwiperMain && typeof productMediaSwiperMain.on === 'function') {
      productMediaSwiperMain.on('init', buildDots);
      productMediaSwiperMain.on('slidesLengthChange', function() { setTimeout(buildDots, 40); });
      productMediaSwiperMain.on('observerUpdate', function() { setTimeout(buildDots, 40); });
      productMediaSwiperMain.on('slideChange', updateActiveDot);
      productMediaSwiperMain.on('transitionEnd', updateActiveDot);
    }

    if (productMediaSwiperThumbs && typeof productMediaSwiperThumbs.on === 'function') {
      productMediaSwiperThumbs.on('init', buildDots);
      productMediaSwiperThumbs.on('observerUpdate', function() { setTimeout(buildDots, 40); });
      productMediaSwiperThumbs.on('slidesLengthChange', function() { setTimeout(buildDots, 40); });
    }

    // arrows
    prevBtn && prevBtn.addEventListener('click', function(){ if (productMediaSwiperMain) productMediaSwiperMain.slidePrev(); });
    nextBtn && nextBtn.addEventListener('click', function(){ if (productMediaSwiperMain) productMediaSwiperMain.slideNext(); });

    // initial try (in case init already happened)
    setTimeout(function(){
      buildDots();
      updateActiveDot();
    }, 160);

    // Observe DOM changes in thumbs container (if theme dynamically injects)
    var mo = null;
    var swiperEl = thumbsRoot.querySelector('.swiper-container');
    if (swiperEl && 'MutationObserver' in window) {
      mo = new MutationObserver(function(){
        var current = getUniqueSlideCount();
        var dotsCount = dotsRow ? dotsRow.children.length : 0;
        if (current !== dotsCount) {
          setTimeout(function(){ buildDots(); updateActiveDot(); }, 80);
        } else {
          // even when count same, widths might need recalculation
          adjustDotWidths();
        }
      });
      mo.observe(swiperEl, { childList: true, subtree: true });
    }

    // Recalculate on window resize (debounced)
    var onResize = debounce(function(){
      adjustDotWidths();
      // ensure active remains visible after resize and re-evaluate centering
      updateActiveDot();
    }, 120);
    window.addEventListener('resize', onResize);

    // Also recalc when fonts/images finish loading (images can affect sizes)
    window.addEventListener('load', function () {
      setTimeout(function(){
        adjustDotWidths();
        updateActiveDot();
      }, 160);
    });
  }

  // Keeps the vertical thumbnail column's height matched to the main image's
  // rendered height, so `.product-media-swiper__thumbs { overflow: hidden }`
  // clips the thumbnail list instead of letting it push the layout tall.
  function setupThumbsHeightSync(thumbsSwiper) {
    var mainEl = document.querySelector('.product-media-swiper__main');
    var thumbsEl = document.querySelector('.product-media-swiper__thumbs');
    if (!mainEl || !thumbsEl) return;

    function syncHeight() {
      // Below 750px the thumbs render as a horizontal strip under the main
      // image (see product-media-swiper.css), not a height-clipped vertical
      // rail beside it — forcing an inline height here would make that strip
      // as tall as the main image instead of hugging the 48px thumbnails.
      if (window.innerWidth < 750) {
        thumbsEl.style.height = '';
        if (thumbsSwiper && typeof thumbsSwiper.update === 'function') {
          thumbsSwiper.update();
        }
        return;
      }
      var height = mainEl.getBoundingClientRect().height;
      if (height > 0) {
        thumbsEl.style.height = height + 'px';
        // Swiper measured the track using the pre-sync (natural/auto) height;
        // it needs to re-measure now that the container has a real, clipped height,
        // otherwise dragging through the thumbnail list doesn't work.
        if (thumbsSwiper && typeof thumbsSwiper.update === 'function') {
          thumbsSwiper.update();
        }
      }
    }

    syncHeight();

    var mainImg = mainEl.querySelector('.swiper-slide-active img, .swiper-slide img');
    if (mainImg && !mainImg.complete) {
      mainImg.addEventListener('load', syncHeight, { once: true });
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(syncHeight).observe(mainEl);
    } else {
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(syncHeight, 100);
      });
    }
  }

  function setupHoverZoom(swiper){
  // nonaktifkan di perangkat touch (biar tidak bentrok dengan gesture)
  var isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (isTouch) return;

  var container = document.querySelector('.product-media-swiper__main .swiper-container');
  if (!container) return;

  var DEFAULT_SCALE = 1.25; // boleh diubah
  var state = { slide: null, img: null };

  function findImg(slide){
    // cari IMG yang terlihat saja
    var img = slide.querySelector('img');
    return (img && img.offsetWidth > 0 && img.offsetHeight > 0) ? img : null;
  }

  function bindSlide(slide){
    if (slide._zoomBound) return;
    slide._zoomBound = true;

    slide.addEventListener('mouseenter', function(){
      // skip video/iframe/deferred
      if (slide.querySelector('deferred-media, iframe, video')) return;
      var img = findImg(slide);
      if (!img) return;

      state.slide = slide;
      state.img = img;

      // siapkan inline style (mengalahkan CSS lain)
      img.style.willChange = 'transform';
      img.style.transition = 'transform 0.18s ease';
      img.style.transform = 'scale(' + DEFAULT_SCALE + ')';
      img.style.transformOrigin = '50% 50%';
      img.style.cursor = 'zoom-out';
    }, { passive: true });

    slide.addEventListener('mousemove', function(e){
      if (!state.img || state.slide !== slide) return;
      var rect = slide.getBoundingClientRect();
      // posisi relatif kursor → persen
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      if (x < 0) x = 0; if (x > 100) x = 100;
      if (y < 0) y = 0; if (y > 100) y = 100;

      // kunci: transformOrigin mengikuti cursor
      state.img.style.transformOrigin = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
    }, { passive: true });

    slide.addEventListener('mouseleave', function(){
      if (!state.img || state.slide !== slide) return;
      // bersihkan inline style
      state.img.style.transform = '';
      state.img.style.transformOrigin = '';
      state.img.style.willChange = '';
      state.img.style.transition = '';
      state.img.style.cursor = '';
      state.slide = null;
      state.img = null;
    }, { passive: true });
  }

  function attachAll(){
    // pakai slide Swiper (termasuk yang aktif)
    var slides = swiper && swiper.slides ? Array.from(swiper.slides) : Array.from(container.querySelectorAll('.swiper-slide'));
    slides.forEach(bindSlide);
  }

  attachAll();

  if (swiper && typeof swiper.on === 'function') {
    // bersihkan zoom saat slide berubah
    swiper.on('slideChange', function(){
      if (state.img) {
        state.img.style.transform = '';
        state.img.style.transformOrigin = '';
        state.img.style.willChange = '';
        state.img.style.transition = '';
        state.img.style.cursor = '';
        state.slide = null;
        state.img = null;
      }
    });
    // rebind saat DOM slide berubah
    swiper.on('observerUpdate', attachAll);
    swiper.on('slidesLengthChange', attachAll);
    swiper.on('init', attachAll);
  }
}

  // SINGLE call only
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.product-media-swiper')) {
      initializeProductMediaSwiper();
    }
  });
})();